export class CustomerSymptomMap {
  id: string;
  label: string;
  customerId: string;
  customerLabel: string;
  createdAt: number;
  updatedAt: number;
}
